import {ChangeDetectorRef, Component, Inject, OnInit} from "@angular/core";
import {svgMagnifyingGlass, svgMagnifyingPlus} from '@shared/utils/svg-helper-data';
import {FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule} from "@angular/forms";
import {
    TrvFormUtilityService,
    TrvGlobalMessagesService,
    TrvModalService,
    TrvSelectOption,
    TrvUtilityService,
    TrvSelectComponent,
    TrvLoadingBundle, trvCollapseVoidAnimation, TrvLoadingDirective
} from "@trv-hub/trv-ng-common";
import Point from "ol/geom/Point";
import {debounceTime, distinctUntilChanged, merge, mergeMap, of, Subject, switchMap} from "rxjs";
import {SvgIcon} from '@shared/utils/svg-helper';
import {
    
    NvdbNavigationService,
    PlatsSearchOption, SearchItem,
    SearchState
} from '@app/service/nvdb-navigation.service';
import {NetDbService} from '@app/service/net-db.service';
import {TrvMapExtensionService} from '@app/service/trv-map-extension.service';
import {Extent} from 'ol/extent'
import {Feature} from 'ol'
import {TrvNgMapService} from '@trafikverket/trv-ng-map'
import {SearchItemComponent} from "./search-item/search-item.component";
import {NgClass} from "@angular/common";
import {SvgIconComponent} from "../../utils/svg-icon/svg-icon.component";
import {environment} from "src/environments/environment";
import { ApmService } from "@app/service/apm.service";
import { SearchRequest } from "@app/_api/njdbpawebb/models";
import { LanguageService } from "@app/service/language.service";

@Component({
    selector: "app-search-section",
    templateUrl: "./search-section.component.html",
    styleUrls: ["./search-section.component.scss"],
    animations: [trvCollapseVoidAnimation],
    imports: [
        ReactiveFormsModule,
        TrvSelectComponent,
        SvgIconComponent,
        NgClass,
        TrvLoadingBundle,
        SearchItemComponent,
        TrvLoadingDirective,
        
    ]
})
export class SearchSectionComponent {
/*
    public searchString = new FormControl<string>("")
    public searchObjectType = new FormControl(searchObjectList[0])
    public platsSearch = new FormControl<{ key: PlatsSearchOption; displayName: string }[]>([], {nonNullable: true});
*/

    displayValue(obj: { key: string, displayName: string }) {
        return obj.displayName
    };

    constructor(
        @Inject(TrvNgMapService) public trvMapService: TrvNgMapService,
        @Inject(TrvGlobalMessagesService)
        private globalMessagesService: TrvGlobalMessagesService,
        @Inject(NvdbNavigationService)
        public nvdbNavigation: NvdbNavigationService,
        @Inject(TrvMapExtensionService)
        public trvMapExtensionService: TrvMapExtensionService,
        private trvUtilityService: TrvUtilityService,
        @Inject(TrvModalService) private trvModalService: TrvModalService,
        @Inject(NetDbService) public netdbService: NetDbService,
        @Inject(ApmService) public apmService: ApmService,
        public lang: LanguageService,
        private cdRef: ChangeDetectorRef,
    ) {

        this.lang.currentLanguage$.subscribe(() => {
            this.cdRef.detectChanges();
        });

        if(environment.application == 'NjdbPåWebb') {
            //Filter out searchObjectList with what we want to show on njdb

            if(!nvdbNavigation.searchObjectList.some(a => a.id === "bandel")){
                nvdbNavigation.searchObjectList.push({order: 8, id: "bandel", displayName: "Bandel"},);
            }

            if(!nvdbNavigation.searchObjectList.some(a => a.id === "trafikplatsjvg")){
                nvdbNavigation.searchObjectList.push({order: 9, id: "trafikplatsjvg", displayName: "Trafikplats"},);
            }

            if(!nvdbNavigation.searchObjectList.some(a => a.id === "trafikplatssignatur")){
                nvdbNavigation.searchObjectList.push({order: 9, id: "trafikplatssignatur", displayName: "Trafikplatssignatur"},);
            }



            nvdbNavigation.searchObjectList = nvdbNavigation.searchObjectList.filter(obj => {
                if(obj.id == "plats") return true;
                if(obj.id == "gatunamn") return true;
                if(obj.id == "bandel") return true;
                if(obj.id == "trafikplatsjvg") return true;
                if(obj.id == "trafikplatssignatur") return true;

                return false;
            });
        }

        if(environment.application == 'JNBKarta') {
            //Filter out searchObjectList with what we want to show on njdb

            if(!nvdbNavigation.searchObjectList.some(a => a.id === "JNBBandel")){
                nvdbNavigation.searchObjectList.push({order: 8, id: "JNBBandel", displayName: lang.GetValue('Searchmenu.RailwaySection')},);
            }
            if(!nvdbNavigation.searchObjectList.some(a => a.id === "JNBTrafikplats")){
                nvdbNavigation.searchObjectList.push({order: 10, id: "JNBTrafikplats", displayName: lang.GetValue('Searchmenu.OperationalPoint')},);
            }
            if(!nvdbNavigation.searchObjectList.some(a => a.id === "JNBStråk")){
                nvdbNavigation.searchObjectList.push({order: 9, id: "JNBStråk", displayName: lang.GetValue('Searchmenu.Route')},);
            }

            nvdbNavigation.availablePlatsSearchFilter = nvdbNavigation.availablePlatsSearchFilter.filter(obj => {

                if(obj.key == PlatsSearchOption.VAGNUMMER) return false;


                return true;
            });

            nvdbNavigation.searchObjectList = nvdbNavigation.searchObjectList.filter(obj => {
                if(obj.id == "plats") obj.order = 8;
                if(obj.id == "plats") obj.displayName = lang.GetValue("Searchmenu.PlaceCoor");
                if(obj.id == "plats") obj.placeholder = lang.GetValue("Searchmenu.PlaceCoorSwe");
                if(obj.id == "JNBBandel") obj.order = 1;
                if(obj.id == "gatunamn") obj.displayName = lang.GetValue("Searchmenu.Street");


                if(obj.id == "plats") return true;
                if(obj.id == "gatunamn") return true;
                if(obj.id == "JNBTrafikplats") return true;
                if(obj.id == "JNBBandel") return true;
                if(obj.id == "JNBStråk") return true;

                return false;
            });
        }

        if (environment.application == "JNBKarta") {
            this.lang.currentLanguage$.subscribe(() => {
              this.nvdbNavigation.siteTitle = this.lang.GetValue("MapMenu.Map");
              this.cdRef.detectChanges();
            });
          }

        merge(this.nvdbNavigation.searchMenuState.platsSearch.valueChanges, this.nvdbNavigation.searchMenuState.searchString.valueChanges, this.nvdbNavigation.searchMenuState.searchObjectType.valueChanges)
            .pipe(
                debounceTime(250), // Adjust the time as needed (1000ms = 1 second)
                distinctUntilChanged(), // Only emit if the value has changed
                switchMap(() => {

                    this.apmService.renameCurrentTransaction("Search place");

                    const platsFilter = this.nvdbNavigation.searchMenuState.platsSearch.value;
                    const searchString = this.nvdbNavigation.searchMenuState.searchString.value?.trim();
                    const objectType = this.nvdbNavigation.searchMenuState.searchObjectType.value;

                    const searchObject: SearchRequest = {
                        driftbidrag_Statlig: true,
                        gatunamn: true,
                        kommun: true,
                        koordinat: true,
                        ort: true,
                        tatort: true,
                        vagnummer: true,
                        searchFor: objectType!.id,
                        searchString: searchString!,
                        bandel: true,
                        trafikplats: true
                    }

                    const filterBasedOnPlats = objectType!.id == 'plats' && platsFilter.length > 0
                    if (filterBasedOnPlats) {
                        searchObject.kommun = platsFilter.some(a => a.key === PlatsSearchOption.KOMMUN)
                        searchObject.koordinat = platsFilter.some(a => a.key === PlatsSearchOption.KOORDINAT)
                        searchObject.ort = platsFilter.some(a => a.key === PlatsSearchOption.ORT)
                        searchObject.tatort = platsFilter.some(a => a.key === PlatsSearchOption.TATORT)
                        searchObject.vagnummer = platsFilter.some(a => a.key === PlatsSearchOption.VAGNUMMER)
                    }

                    if (searchString!.length == 0) {
                        this.nvdbNavigation.searchMenuState.searchState = SearchState.None;
                        return of(null);
                    } else if (searchString!.length == 1 && !searchObject.vagnummer) {
                        this.nvdbNavigation.searchMenuState.searchState = SearchState.ToShortString;
                        return of(null);
                    }

                    this.nvdbNavigation.searchMenuState.searchState = SearchState.Loading;

                    return this.netdbService.searchAll(searchObject);
                })
            )
            .subscribe(searchResult => {
                if(searchResult) this.generateSearchObjects(searchResult);
            });
    }

    ngAfterViewInit() {
        if (environment.application === "JNBKarta") {
          this.lang.currentLanguage$.subscribe(() => {
      
            // 1. Lägg till objekt om de saknas
            const addOrUpdate = (id: string, order: number, getDisplayName: () => string) => {
              const obj = this.nvdbNavigation.searchObjectList.find(a => a.id === id);
              if (obj) {
                obj.order = order;
                obj.displayName = getDisplayName();
              } else {
                this.nvdbNavigation.searchObjectList.push({
                  order,
                  id,
                  displayName: getDisplayName()
                });
              }
            };
      
            addOrUpdate("JNBBandel", 1, () => this.lang.GetValue('Searchmenu.RailwaySection'));
            addOrUpdate("JNBTrafikplats", 10, () => this.lang.GetValue('Searchmenu.OperationalPoint'));
            addOrUpdate("JNBStråk", 9, () => this.lang.GetValue('Searchmenu.Route'));
            addOrUpdate("plats", 8, () => this.lang.GetValue("Searchmenu.PlaceCoor"));
            addOrUpdate("gatunamn", 2, () => this.lang.GetValue("Searchmenu.Street"));

      
            // 2. Filtrera bort VAGNUMMER
            this.nvdbNavigation.availablePlatsSearchFilter = this.nvdbNavigation.availablePlatsSearchFilter.filter(
              obj => obj.key !== PlatsSearchOption.VAGNUMMER
            );
      
            // 3. Uppdatera placeholder för "plats"
            const platsObj = this.nvdbNavigation.searchObjectList.find(o => o.id === "plats");
            if (platsObj) {
              platsObj.placeholder = this.lang.GetValue("Searchmenu.PlaceCoorSwe");
            }
      
            // 4. Filtrera listan så vi bara behåller relevanta objekt
            this.nvdbNavigation.searchObjectList = this.nvdbNavigation.searchObjectList.filter(obj =>
              ["plats", "gatunamn", "JNBTrafikplats", "JNBBandel", "JNBStråk"].includes(obj.id)
            );
      
            // 5. Uppdatera siteTitle
            this.nvdbNavigation.siteTitle = this.lang.GetValue("MapMenu.Map");
      
            this.cdRef.detectChanges();
          });
        }
      }
      

    public generateSearchObjects(_res: string) {
        this.nvdbNavigation.searchMenuState.currentSearchItems = [];
        let res = JSON.parse(_res);
        if (Array.isArray(res)) {
            //Begin with sorting array by elem.Type?
            res.sort((a, b) => a.Type - b.Type);

            res.forEach((elem: any) => {
                let searchFeature = this.trvMapService.trvMap?.trvLayer.getFeatureFromWkt(elem.WKT);
                let extent = searchFeature?.getGeometry()?.getExtent();
                if (extent) {
                    //If searchFeature is a point, extend the extent
                    if (searchFeature?.getGeometry() instanceof Point) {
                        let offset = [2000, 2000];
                        extent[0] = extent[0] - offset[0];
                        extent[1] = extent[1] - offset[1];
                        extent[2] = extent[2] + offset[0];
                        extent[3] = extent[3] + offset[1];
                    }

                    var subTitle: string = "";
                    var title = elem.Name;
                    if (elem.Type == 0) {
                        subTitle = "Tätort • " + elem.Kommun + " kommun • " + elem.Lan;
                    } else if (elem.Type == 1) {
                        subTitle = "Kommun • " + elem.Lan;
                    } else if (elem.Type == 2) {
                        subTitle = "Ort • " + elem.Kommun + " kommun • " + elem.Lan;
                    } else if (elem.Type == 3) {
                        subTitle = elem.Kommun + " kommun";
                    } else if (elem.Type == 4) {
                        title = "Driftbidrag statligt: " + elem.Name;
                        subTitle = elem.Kommun + " kommun";
                    } else if (elem.Type == 5) {
                        title = "Omledningsnamn: " + elem.Name;
                        subTitle = elem.Kommun + " kommun";
                    } else if (elem.Type == 6) {
                        title = elem.Name;
                        subTitle = elem.Kommun + " kommun, Identitet:" + elem.Code;
                    } else if (elem.Type == 7) {
                        title = elem.Name;
                        subTitle = "Sweref99tm";
                    } else if (elem.Type == 8) {
                        title = elem.Name;
                        subTitle = "Feature_OID: " + elem.Code;
                    } else if (elem.Type == 9) {
                        title = "Element id: " + elem.Name;
                        subTitle = elem.Kommun + " kommun";
                    } else if (elem.Type == 10) {
                        title = elem.Code + " " + elem.Name;
                        subTitle = elem.Lan;
                    } else if (elem.Type == 11) {
                        title = elem.Name;
                        subTitle = "Bandel: " + elem.Code;
                    } else if (elem.Type == 12) {
                        title = elem.Name + " - " + elem.Code;
                        subTitle = elem.Kommun;
                    } else if (elem.Type == 13) {
                        title = elem.Name;
                        subTitle = "WGS 84";
                    } else if (elem.Type == 14) {
                        title = elem.Name;
                        subTitle = "Stråk: hej";
                    }

                    let searchItem: SearchItem = {
                        title: title,
                        subTitle: subTitle,
                        extent: extent,
                        feature: searchFeature,
                        type: elem.Type,
                    };

                    this.nvdbNavigation.searchMenuState.currentSearchItems.push(searchItem);
                }
            });
        }
        if (this.nvdbNavigation.searchMenuState.currentSearchItems.length == 0) this.nvdbNavigation.searchMenuState.searchState = SearchState.NoResults;
        else this.nvdbNavigation.searchMenuState.searchState = SearchState.Success;
    }

    public searchIcon: SvgIcon = svgMagnifyingGlass;
    SearchState = SearchState
}

